import { render, staticRenderFns } from "./ServicePanel.vue?vue&type=template&id=22d5b095&scoped=true&"
import script from "./ServicePanel.vue?vue&type=script&lang=js&"
export * from "./ServicePanel.vue?vue&type=script&lang=js&"
import style0 from "./ServicePanel.vue?vue&type=style&index=0&id=22d5b095&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d5b095",
  null
  
)

export default component.exports